import { render, staticRenderFns } from "./AsignacionSeriado.vue?vue&type=template&id=06ed1ab4&"
import script from "./AsignacionSeriado.vue?vue&type=script&lang=ts&"
export * from "./AsignacionSeriado.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionSeriado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('06ed1ab4', component.options)
    } else {
      api.reload('06ed1ab4', component.options)
    }
    module.hot.accept("./AsignacionSeriado.vue?vue&type=template&id=06ed1ab4&", function () {
      api.rerender('06ed1ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/PreparacionEquipos/AsignacionSeriado.vue"
export default component.exports